import { Button, Tooltip, useTheme, IconButton, useMediaQuery } from '@mui/material';

import { useAuthContext } from 'src/hooks/auth/use-auth-context';

import { localStorageGetItem } from 'src/utils/local-storage';
import { sessionStorageGetItem } from 'src/utils/session-storage';

import { useTranslate } from 'src/locales';
import { ENGAGE_APP_URL } from 'src/config-global';
import { TAKEOVER_STORAGE_KEY } from 'src/services/system/system.types';

import Iconify from 'src/components/iconify';

/**
 * Opens Engage in a new tab, signed in with the user's JobTetris token (JT1-1846).
 *
 * Shown only when Engage has an address, the user has Engage switched on, and no support
 * takeover is active: during a takeover Engage would sign in as the support person, not the
 * user being impersonated. The token goes in the URL fragment so it never reaches a server or
 * a Referer header.
 */
export const EngageLaunchButton = () => {
  const { t } = useTranslate();

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const authContext = useAuthContext();

  const takeoverActive = !!sessionStorageGetItem(TAKEOVER_STORAGE_KEY);

  if (!ENGAGE_APP_URL || authContext?.account?.engage_access !== true || takeoverActive) {
    return null;
  }

  const handleClick = () => {
    const token = localStorageGetItem('access_token', '') ?? '';
    window.open(`${ENGAGE_APP_URL}/auth/callback#jt_token=${encodeURIComponent(token)}`, '_blank', 'noopener,noreferrer');
  };

  if (isMobile) {
    return (
      <Tooltip title={t('components.engage_launch.tooltip')}>
        <IconButton color="primary" onClick={handleClick} aria-label={t('components.engage_launch.label')}>
          <Iconify icon="mdi:email-fast-outline" />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('components.engage_launch.tooltip')}>
      <Button
        variant="outlined"
        color="primary"
        startIcon={<Iconify icon="mdi:email-fast-outline" />}
        onClick={handleClick}
      >
        {t('components.engage_launch.label')}
      </Button>
    </Tooltip>
  );
};
